/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAllServiceProviders200ResponseServiceProvidersInnerClients } from './GetAllServiceProviders200ResponseServiceProvidersInnerClients';
import {
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsFromJSON,
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsFromJSONTyped,
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsToJSON,
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsToJSONTyped,
} from './GetAllServiceProviders200ResponseServiceProvidersInnerClients';

/**
 * 
 * @export
 * @interface GetAllServiceProviders200ResponseServiceProvidersInner
 */
export interface GetAllServiceProviders200ResponseServiceProvidersInner {
    /**
     * 
     */
    uuid?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    createdAt?: string | null;
    /**
     * 
     */
    clients?: GetAllServiceProviders200ResponseServiceProvidersInnerClients;
}

/**
 * Check if a given object implements the GetAllServiceProviders200ResponseServiceProvidersInner interface.
 */
export function instanceOfGetAllServiceProviders200ResponseServiceProvidersInner(value: object): value is GetAllServiceProviders200ResponseServiceProvidersInner {
    return true;
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerFromJSON(json: any): GetAllServiceProviders200ResponseServiceProvidersInner {
    return GetAllServiceProviders200ResponseServiceProvidersInnerFromJSONTyped(json, false);
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllServiceProviders200ResponseServiceProvidersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'name': json['name'] == null ? undefined : json['name'],
        'createdAt': json['createdAt'] === undefined ? undefined : json['createdAt'] === null ? null : json['createdAt'],
        'clients': json['clients'] == null ? undefined : GetAllServiceProviders200ResponseServiceProvidersInnerClientsFromJSON(json['clients']),
    };
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerToJSON(json: any): GetAllServiceProviders200ResponseServiceProvidersInner {
    return GetAllServiceProviders200ResponseServiceProvidersInnerToJSONTyped(json, false);
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerToJSONTyped(value?: GetAllServiceProviders200ResponseServiceProvidersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'name': value['name'],
        'createdAt': value['createdAt'],
        'clients': GetAllServiceProviders200ResponseServiceProvidersInnerClientsToJSON(value['clients']),
    };
}

